
import React from "react";
import { Button } from "@/components/ui/button";
import { Save, RefreshCw } from "lucide-react";

interface RollenBeheerHeaderProps {
  isDirty: boolean;
  isLoading: boolean;
  isSaving: boolean;
  onRefresh: () => void;
  onSave: () => void;
}

const RollenBeheerHeader: React.FC<RollenBeheerHeaderProps> = ({
  isDirty,
  isLoading,
  isSaving,
  onRefresh,
  onSave
}) => {
  return (
    <div className="flex justify-between items-center">
      <h1 className="text-2xl font-bold">Rollenbeheer</h1>
      <div className="flex space-x-2">
        <Button 
          variant="outline"
          onClick={onRefresh}
          disabled={isLoading || isSaving}
          className="border-gray-300"
        >
          <RefreshCw className="mr-2 h-4 w-4" />
          Herladen
        </Button>
        <Button 
          onClick={onSave} 
          disabled={!isDirty || isLoading || isSaving}
          className={isDirty ? "bg-green-600 hover:bg-green-700 text-white shadow-sm" : ""}
        >
          <Save className="mr-2 h-4 w-4" />
          {isSaving ? "Opslaan..." : "Opslaan"}
        </Button>
      </div>
    </div>
  );
};

export default RollenBeheerHeader;
